import { Resource } from '@types'
import { client } from './client'

const resourcesService = async (cocap: string) => {
  const { data } = await client.get('/resources', {
    headers: {
      cocap
    }
  })
  return data
}

const createResourceService = async (cocap: string, resource: Resource) => {
  const { data } = await client.post(
    '/resources',
    {
      ...resource
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

const patchResourceService = async (resourceId: string, cocap: string, resource: Resource) => {
  const { data } = await client.patch(
    `/resources/${resourceId}`,
    {
      ...resource
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

const deleteResourceService = async (resourceId: string, cocap: string) => {
  const { data } = await client.delete(`/resources/${resourceId}`, {
    headers: {
      cocap
    }
  })
  return data
}

export { resourcesService, patchResourceService, createResourceService, deleteResourceService }
